export const apiUrl = {
  REGISTER: 'Account/Register',
  LOGIN: 'Account/Login',
  GENERATE_NEW_TOKEN: 'Account/GenerateNewTokenForCurrentUser',
  FORGOT_PASSWORD: 'Account/ForgotPassword',
  RESET_PASSWORD: 'Account/ResetPassword',
  CHANGE_PASSWORD: 'Account/ChangePassword',
  GET_CURRENT_USER: 'Account/GetCurrentUser',
  GENERATE_NEW_TOKEN_FOR_CURRENT_USER: 'Account/GenerateNewTokenForCurrentUser',
  CHANGE_CREDENTIALS: 'Account/ChangeCredentials',

  ACCOUNTING_DOCUMENT_LIST: 'AccountingDocument/GetList',
  ACCOUNTING_DOCUMENT_ITEM: 'AccountingDocument/GetItem',
  ACCOUNTING_DOCUMENT_CREATE: 'AccountingDocument/CreateItem',
  ACCOUNTING_DOCUMENT_UPDATE: 'AccountingDocument/EditItem',
  ACCOUNTING_DOCUMENT_DELETE: 'AccountingDocument/DeleteItem',
  ACCOUNTING_DOCUMENT_GENERATE_NUM: 'AccountingDocument/GenerateNewDocumentNumber',
  ACCOUNTING_DOCUMENT_GENERATE_VS: 'AccountingDocument/GenerateNewVariableSymbolNumber',
  ACCOUNTING_DOCUMENT_GET_PDF: 'AccountingDocument/GetPdf',
  ACCOUNTING_DOCUMENT_ITEM_HINT: 'AccountingDocument/GetAccountingDocumentItemHints',
  ACCOUNTING_DOCUMENT_SUBSCRIBER_HINT: 'AccountingDocument/GetAccountingDocumentSubscriberHints',
  ACCOUNTING_DOCUMENT_SUBSCRIBER_DELIVERY_HINT:
    'AccountingDocument/GetAccountingDocumentSubscriberDeliveryHints',
  ACCOUNTING_DOCUMENT_UPDATE_STATUS: 'AccountingDocument/UpdateDocumentStatus',
  ACCOUNTING_DOCUMENT_LINKED_DOC_LIST:
    'AccountingDocument/GetAccountingDocumentAccountingDocuments',
  ACCOUNTING_DOCUMENT_LINKED_DOC_POST:
    'AccountingDocument/LinkAccountingDocumentToAccountingDocument',
  ACCOUNTING_DOCUMENT_LINKED_DOC_DELETE:
    'AccountingDocument/UnlinkAccountingDocumentFromAccountingDocument',
  ACCOUNTING_DOCUMENT_ISSUE: 'AccountingDocument/IssueDocument',
  ACCOUNTING_DOCUMENT_COPY: 'AccountingDocument/CreateDocumentCopy',
  ACCOUNTING_DOCUMENT_ITEM_HINTS_MERGED:
    'AccountingDocument/GetAccountingDocumentItemHintsMergedWithCodeBookItems',
  ACCOUNTING_DOCUMENT_GET_PAYMENT_LIST: 'AccountingDocument/GetAccountingDocumentPaymentState',
  ACCOUNTING_DOCUMENT_CREATE_DOC_FROM_FILE: 'AccountingDocument/CreateDocumentFromFile',

  ACCOUNTING_DOCUMENT_MESSAGE_LIST: 'AccountingDocumentMessage/GetList',
  ACCOUNTING_DOCUMENT_MESSAGE_ITEM: 'AccountingDocumentMessage/GetItem',
  ACCOUNTING_DOCUMENT_MESSAGE_CREATE: 'AccountingDocumentMessage/CreateItem',
  ACCOUNTING_DOCUMENT_MESSAGE_UPDATE: 'AccountingDocumentMessage/EditItem',
  ACCOUNTING_DOCUMENT_MESSAGE_DELETE: 'AccountingDocumentMessage/DeleteItem',

  PAYMENT_CREATE: 'Payment/CreateItem',
  PAYMENT_UPDATE: 'Payment/UpdateItem',
  PAYMENT_DELETE: 'Payment/DeleteItem',
  PAYMENT_ITEM: 'Payment/GetItem',
  PAYMENT_LIST: 'Payment/GetList',

  OPTIONAL_FIELD_LIST: 'OptionalField/GetList',
  OPTIONAL_FIELD_ITEM: 'OptionalField/GetItem',
  OPTIONAL_FIELD_CREATE: 'OptionalField/CreateItem',
  OPTIONAL_FIELD_UPDATE: 'OptionalField/UpdateItem',
  OPTIONAL_FIELD_DELETE: 'OptionalField/DeleteItem',

  SMART_ATTACHMENT_GET_PDF: 'SmartAttachment/GetPdf',
  SMART_ATTACHMENT_LIST: 'SmartAttachment/GetList',
  SMART_ATTACHMENT_ITEM: 'SmartAttachment/GetItem',
  SMART_ATTACHMENT_CREATE: 'SmartAttachment/CreateItem',
  SMART_ATTACHMENT_UPDATE: 'SmartAttachment/UpdateItem',
  SMART_ATTACHMENT_DELETE: 'SmartAttachment/DeleteItem',

  CHAT_CREATE: 'Chat/CreateItem',
  CHAT_UPDATE: 'Chat/UpdateItem',
  CHAT_DELETE: 'Chat/DeleteItem',
  CHAT_LIST: 'Chat/GetList',
  CHAT_ITEM: 'Chat/GetItem',
  CHAT_ACCOUNTING_DOCUMENT_ATTACHMENT_CREATE: 'ChatAccountingDocumentAttachment/CreateItem',
  CHAT_ACCOUNTING_DOCUMENT_ATTACHMENT_UPDATE: 'ChatAccountingDocumentAttachment/UpdateItem',
  CHAT_ACCOUNTING_DOCUMENT_ATTACHMENT_DELETE: 'ChatAccountingDocumentAttachment/DeleteItem',
  CHAT_ACCOUNTING_DOCUMENT_ATTACHMENT_LIST: 'ChatAccountingDocumentAttachment/GetList',
  CHAT_ACCOUNTING_DOCUMENT_ATTACHMENT_ITEM: 'ChatAccountingDocumentAttachment/GetItem',
  CHAT_FILE_ATTACHMENT_CREATE: 'ChatFileAttachment/CreateItem',
  CHAT_FILE_ATTACHMENT_UPDATE: 'ChatFileAttachment/UpdateItem',
  CHAT_FILE_ATTACHMENT_DELETE: 'ChatFileAttachment/DeleteItem',
  CHAT_FILE_ATTACHMENT_LIST: 'ChatFileAttachment/GetList',
  CHAT_FILE_ATTACHMENT_ITEM: 'ChatFileAttachment/GetItem',
  CHAT_MESSAGE_CREATE: 'ChatMessage/CreateItem',
  CHAT_MESSAGE_UPDATE: 'ChatMessage/UpdateItem',
  CHAT_MESSAGE_DELETE: 'ChatMessage/DeleteItem',
  CHAT_MESSAGE_LIST: 'ChatMessage/GetList',
  CHAT_MESSAGE_ITEM: 'ChatMessage/GetItem',
  CHAT_TASK_ATTACHMENT_CREATE: 'ChatUserTaskAttachment/CreateItem',
  CHAT_TASK_ATTACHMENT_UPDATE: 'ChatUserTaskAttachment/UpdateItem',
  CHAT_TASK_ATTACHMENT_DELETE: 'ChatUserTaskAttachment/DeleteItem',
  CHAT_TASK_ATTACHMENT_LIST: 'ChatUserTaskAttachment/GetList',
  CHAT_TASK_ATTACHMENT_ITEM: 'ChatUserTaskAttachment/GetItem',

  ACCOUNTING_DOCUMENT_LINK_OPTIONAL_FIELD:
    'AccountingDocument/LinkOptionalFieldOnAccountingDocument',
  ACCOUNTING_DOCUMENT_UNLINK_OPTIONAL_FIELD:
    'AccountingDocument/UnlinkOptionalFieldFromAccountingDocument',

  COMPANY_CREATE: 'Company/CreateItem',
  COMPANY_UPDATE: 'Company/UpdateItem',
  COMPANY_DELETE: 'Company/DeleteItem',
  COMPANY_LIST: 'Company/GetList',
  COMPANY_GET: 'Company/GetItem',
  COMPANY_GET_USERS_COMPANIES: 'Company/GetUsersCompanies',
  COMPANY_SEARCH_BY_ID: 'Company/SearchByCompanyId',
  COMPANY_LOGO_ITEM: 'Company/GetCompanyLogo',
  COMPANY_LOGO_UPLOAD: 'Company/UploadCompanyLogo',
  COMPANY_LOGO_DELETE: 'Company/DeleteCompanyLogo',

  COMPANY_CURRENCY_RATES_GET_MODEL: 'CompanyCurrencyRate/GetCurrencyModel',
  COMPANY_CURRENCY_RATES_DATE_OF_MODEL: 'CompanyCurrencyRate/GetCurrencyDateAccordingToModel',
  COMPANY_CURRENCY_RATES_CREATE: 'CompanyCurrencyRate/CreateItem',
  COMPANY_CURRENCY_RATES_UPDATE: 'CompanyCurrencyRate/UpdateItem',
  COMPANY_CURRENCY_RATES_DELETE: 'CompanyCurrencyRate/DeleteItem',
  COMPANY_CURRENCY_RATES_LIST: 'CompanyCurrencyRate/GetList',
  COMPANY_CURRENCY_RATES_ITEM: 'CompanyCurrencyRate/GetItem',

  CURRENCY_GET_DEFAULT_CURRENCY: 'Currency/GetDefaultCurrency',
  CURRENCY_GET_LIST: 'Currency/GetCurrencies',

  ISSUED_DOCUMENTS_EXPORT: 'Export/GetIssuedInvoiceItems',

  COMPANY_BANK_ACCOUNT_CREATE: 'CompanyBankAccount/CreateItem',
  COMPANY_BANK_ACCOUNT_UPDATE: 'CompanyBankAccount/UpdateItem',
  COMPANY_BANK_ACCOUNT_DELETE: 'CompanyBankAccount/DeleteItem',
  COMPANY_BANK_ACCOUNT_LIST: 'CompanyBankAccount/GetList',
  COMPANY_BANK_ACCOUNT_ITEM: 'CompanyBankAccount/GetItem',

  NUMERICAL_SERIES_SUPPORTED_SYMBOLS: 'NumericalSeries/SupportedSymbols',
  NUMERICAL_SERIES_CREATE: 'NumericalSeries/CreateItem',
  NUMERICAL_SERIES_UPDATE: 'NumericalSeries/UpdateItem',
  NUMERICAL_SERIES_DELETE: 'NumericalSeries/DeleteItem',
  NUMERICAL_SERIES_LIST: 'NumericalSeries/GetList',
  NUMERICAL_SERIES_ITEM: 'NumericalSeries/GetItem',
  NUMERICAL_SERIES_SET_COUNTER: 'NumericalSeries/SetCounter',

  FILE_LIST: 'File/GetList',
  FILE_UPLOAD: 'File/UploadFile',
  FILE_UPLOAD_AND_ASSIGN: 'File/UploadAndAssign',
  FILE_DOWNLOAD: 'File/Download',
  FILE_DOWNLOAD_LOGO: 'File/DownloadLogo',
  FILE_DELETE: 'File/Delete',
  FILE_ASSIGN_ATTACHMENT: 'File/AssignAttachment',

  TEAM_CREATE: 'Team/CreateItem',
  TEAM_UPDATE: 'Team/UpdateItem',
  TEAM_DELETE: 'Team/DeleteItem',
  TEAM_LIST: 'Team/GetList',
  TEAM_GET: 'Team/GetItem',
  TEAM_GET_USERS_TEAMS: 'Team/GetUsersTeams',
  TEAM_GET_COMPANY_TEAMS: 'Team/GetCompanyTeams',

  TEAM_MEMBER_CREATE: 'TeamMember/CreateItem',
  TEAM_MEMBER_UPDATE: 'TeamMember/UpdateItem',
  TEAM_MEMBER_DELETE: 'TeamMember/DeleteItem',
  TEAM_MEMBER_LIST: 'TeamMember/GetList',
  TEAM_MEMBER_GET: 'TeamMember/GetItem',

  COMPANY_TEAM_MEMBER_CREATE: 'CompanyTeamMember/CreateItem',
  COMPANY_TEAM_MEMBER_UPDATE: 'CompanyTeamMember/UpdateItem',
  COMPANY_TEAM_MEMBER_DELETE: 'CompanyTeamMember/DeleteItem',
  COMPANY_TEAM_MEMBER_LIST: 'CompanyTeamMember/GetList',
  COMPANY_TEAM_MEMBER_GET: 'CompanyTeamMember/GetItem',

  COMPANY_TEAM_MEMBER_PERMISSION_CREATE: 'CompanyTeamMemberPermission/CreateItem',
  COMPANY_TEAM_MEMBER_PERMISSION_UPDATE: 'CompanyTeamMemberPermission/UpdateItem',
  COMPANY_TEAM_MEMBER_PERMISSION_DELETE: 'CompanyTeamMemberPermission/DeleteItem',
  COMPANY_TEAM_MEMBER_PERMISSION_LIST: 'CompanyTeamMemberPermission/GetList',
  COMPANY_TEAM_MEMBER_PERMISSION_GET: 'CompanyTeamMemberPermission/GetItem',

  TEAM_MEMBER_PERMISSION_ADJUSTMENT_CREATE: 'TeamMemberPermissionAdjustment/CreateItem',
  TEAM_MEMBER_PERMISSION_ADJUSTMENT_UPDATE: 'TeamMemberPermissionAdjustment/UpdateItem',
  TEAM_MEMBER_PERMISSION_ADJUSTMENT_DELETE: 'TeamMemberPermissionAdjustment/DeleteItem',
  TEAM_MEMBER_PERMISSION_ADJUSTMENT_LIST: 'TeamMemberPermissionAdjustment/GetList',
  TEAM_MEMBER_PERMISSION_ADJUSTMENT_GET: 'TeamMemberPermissionAdjustment/GetItem',

  VAT_CODE_GET_LIST_FILTERED: 'VatCode/GetListFiltered',
  VAT_CODE_CREATE: 'VatCode/CreateItem',
  VAT_CODE_UPDATE: 'VatCode/UpdateItem',
  VAT_CODE_DELETE: 'VatCode/DeleteItem',
  VAT_CODE_LIST: 'VatCode/GetList',
  VAT_CODE_ITEM: 'VatCode/GetItem',

  VAT_CODE_TEXT_NOTE_CREATE: 'VatCodeTextNote/CreateItem',
  VAT_CODE_TEXT_NOTE_UPDATE: 'VatCodeTextNote/UpdateItem',
  VAT_CODE_TEXT_NOTE_DELETE: 'VatCodeTextNote/DeleteItem',
  VAT_CODE_TEXT_NOTE_LIST: 'VatCodeTextNote/GetList',
  VAT_CODE_TEXT_NOTE_ITEM: 'VatCodeTextNote/GetItem',

  CODE_BOOK_ITEM_CREATE: 'CodeBookItem/CreateItem',
  CODE_BOOK_ITEM_UPDATE: 'CodeBookItem/UpdateItem',
  CODE_BOOK_ITEM_DELETE: 'CodeBookItem/DeleteItem',
  CODE_BOOK_ITEM_LIST: 'CodeBookItem/GetList',
  CODE_BOOK_ITEM_LIST_WITH_PRICES: 'CodeBookItem/GetListWithPrices',
  CODE_BOOK_ITEM_ITEM: 'CodeBookItem/GetItem',
  CODE_BOOK_ITEM_IMPORT_FROM_EXCEL: 'CodeBookItem/ImportFromExcel',
  CODE_BOOK_ITEM_DOWNLOAD_TEMPLATE: 'CodeBookItem/DownloadCodebookPriceImportTemplate',

  CODE_BOOK_ITEM_PRICE_CREATE: 'CodeBookItemPrice/CreateItem',
  CODE_BOOK_ITEM_PRICE_UPDATE: 'CodeBookItemPrice/UpdateItem',
  CODE_BOOK_ITEM_PRICE_DELETE: 'CodeBookItemPrice/DeleteItem',
  CODE_BOOK_ITEM_PRICE_LIST: 'CodeBookItemPrice/GetList',
  CODE_BOOK_ITEM_PRICE_ITEM: 'CodeBookItemPrice/GetItem',

  USER_TASK_ASSIGN: 'UserTask/AssignToUser',
  USER_TASK_UPDATE_STATE: 'UserTask/UpdateUserTaskState',
  USER_TASK_CREATE: 'UserTask/CreateItem',
  USER_TASK_UPDATE: 'UserTask/UpdateItem',
  USER_TASK_DELETE: 'UserTask/DeleteItem',
  USER_TASK_LIST: 'UserTask/GetList',
  USER_TASK_LIST_FILTERED: 'UserTask/GetListWithFilter',
  USER_TASK_ITEM: 'UserTask/GetItem',

  USER_TASK_HISTORY_LIST: 'UserTaskHistory/GetList',
  USER_TASK_HISTORY_ITEM: 'UserTaskHistory/GetItem',

  LANG_GET_SETTING: 'Language/GetSetting',
};
